import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
};

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `<svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 18.7522C9.9997 18.4204 9.86606 18.1023 9.62844 17.8678L3.14971 11.4672C2.95362 11.2736 2.79806 11.0436 2.69193 10.7905C2.5858 10.5374 2.53117 10.2662 2.53117 9.99223C2.53117 9.71829 2.5858 9.44703 2.69193 9.19394C2.79806 8.94086 2.95362 8.71091 3.14971 8.51723L9.61999 2.1208C9.85073 1.88478 9.97841 1.56866 9.97552 1.24055C9.97263 0.912428 9.83942 0.598556 9.60456 0.366533C9.36971 0.134509 9.052 0.00289857 8.71988 4.7307e-05C8.38776 -0.00280395 8.06779 0.123332 7.82889 0.351289L1.35861 6.74271C0.488613 7.60391 -9.53674e-07 8.77093 0 9.98765C-9.53674e-07 11.2044 0.488613 12.3714 1.35861 13.2326L7.83733 19.6332C8.01423 19.8081 8.2396 19.9272 8.48499 19.9757C8.73039 20.0242 8.98482 19.9998 9.21618 19.9055C9.44754 19.8113 9.64545 19.6514 9.78495 19.4462C9.92445 19.2409 9.99928 18.9994 10 18.7522Z" fill="white"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.995 511.995" width="30" height="30">
    <path d="M381.039,248.62L146.373,3.287c-4.083-4.229-10.833-4.417-15.083-0.333c-4.25,4.073-4.396,10.823-0.333,15.083    L358.56,255.995L130.956,493.954c-4.063,4.26-3.917,11.01,0.333,15.083c2.063,1.979,4.729,2.958,7.375,2.958    c2.813,0,5.604-1.104,7.708-3.292L381.039,263.37C384.977,259.245,384.977,252.745,381.039,248.62z"/>
</svg>`,
        innerHTML: /* html */ `<svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 18.7522C0.00029565 18.4204 0.133945 18.1023 0.371564 17.8678L6.85029 11.4672C7.04638 11.2736 7.20194 11.0436 7.30807 10.7905C7.4142 10.5374 7.46883 10.2662 7.46883 9.99223C7.46883 9.71829 7.4142 9.44703 7.30807 9.19394C7.20194 8.94086 7.04638 8.71091 6.85029 8.51723L0.380008 2.1208C0.14927 1.88478 0.0215939 1.56867 0.02448 1.24055C0.0273661 0.912428 0.160583 0.598556 0.395439 0.366533C0.630294 0.134509 0.947997 0.00289857 1.28012 4.7307e-05C1.61224 -0.00280395 1.93221 0.123332 2.17111 0.351289L8.64139 6.74271C9.51139 7.60391 10 8.77093 10 9.98765C10 11.2044 9.51139 12.3714 8.64139 13.2326L2.16267 19.6332C1.98577 19.8081 1.7604 19.9272 1.51501 19.9757C1.26961 20.0242 1.01518 19.9998 0.783821 19.9055C0.552464 19.8113 0.354548 19.6514 0.215049 19.4462C0.0755506 19.2409 0.000719734 18.9994 0 18.7522Z" fill="white"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
